import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { HintButton } from '../HintButton/HintButton';
import { MoneyText } from '../MoneyText/MoneyText';

import './PhraseAutoStrategyPriceInfoCell.css';
import * as keyset from './PhraseAutoStrategyPriceInfoCell.i18n';

const i18n = i18nFactory(keyset);

export interface PhraseAutoStrategyPriceInfoCellProps {
    isGridScrolling: boolean;
    bid?: number;
}

export interface PhraseAutoStrategyPriceInfoCellState {
    isTooltipVisible: boolean;
}

export class PhraseAutoStrategyPriceInfoCell extends React.Component<
    PhraseAutoStrategyPriceInfoCellProps,
    PhraseAutoStrategyPriceInfoCellState
> {
    static getDerivedStateFromProps(
        nextProps: PhraseAutoStrategyPriceInfoCellProps
    ) {
        if (nextProps.isGridScrolling) {
            return {
                isTooltipVisible: false
            };
        }

        return null;
    }

    constructor(props: PhraseAutoStrategyPriceInfoCellProps) {
        super(props);

        this.state = {
            isTooltipVisible: false
        };
    }

    render() {
        const { isTooltipVisible } = this.state;
        const { bid } = this.props;

        return (
            <>
                {bid ? (
                    <HintButton
                        isActive={isTooltipVisible}
                        onMouseLeave={this.onMouseLeave}
                        onMouseOver={this.onMouseOver}
                        tooltipText={this.getAutoStrategyTooltipInfo()}
                    >
                        <MoneyText num={bid} />
                    </HintButton>
                ) : (
                    '–'
                )}
            </>
        );
    }

    private onMouseLeave = () => {
        this.setState({
            isTooltipVisible: false
        });
    };

    private onMouseOver = () => {
        this.setState({
            isTooltipVisible: true
        });
    };

    private getAutoStrategyTooltipInfo = () => {
        return (
            <div
                className={Bem.cls(
                    'phrase-auto-strategy-price-info-cell',
                    'tooltip-text'
                )}
            >
                {i18n('bid-auto-strategy-info')}
            </div>
        );
    };
}
